export const EDIT_BUTTON_HELP_MESSAGE = 'Edit modifier set.';
export const COLLAPSE_BUTTON_HELP_MESSAGE = 'Collapse modifier set.';
export const EXPAND_BUTTON_HELP_MESSAGE = 'Expand modifier set.';
export const CONFIRMATION_DELETE_MESSAGE = 'Are you sure you want to delete this set?';
